export default {
  'Start at': 'Começar em',
  'Set to current time': 'Definir para o momento atual',
  'Audio volume': 'Volume do áudio',
  'Video volume': 'Volume do vídeo',
  'Trim audio': 'Cortar áudio',
  'Audio will end with the video': 'Áudio irá terminar junto com vídeo.',
  'Trim': 'Cortar',
}